<template>
  <router-view />
</template>

<script setup>
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100%;

  .el-backtop {
    background: var(--color-bg-card, #fff);
    border: 2px solid var(--color-border-dashed, #D4A04A);
    border-radius: 50%;
    box-shadow: 0 3px 0 #C08B3E, 0 4px 12px rgba(180, 120, 40, 0.1);

    .el-icon {
      color: var(--color-primary, #D4880F);
    }

    &:hover {
      background: linear-gradient(180deg, #FDEAC2 0%, #F5C882 100%);
      border-color: var(--color-primary, #D4880F);

      .el-icon {
        color: var(--color-primary-dark, #A86B08);
      }
    }
  }
}

// ElMessageBox overlay
.el-overlay:has(.messageBox) {
  background-color: rgba(61, 44, 30, 0.35) !important;
  backdrop-filter: blur(4px);
}

// ElMessageBox custom style
.el-message-box.messageBox {
  background: var(--color-bg-card, #fff) !important;
  border: 2px solid var(--color-border-dashed, #D4A04A) !important;
  border-radius: 20px !important;
  box-shadow: 0 4px 0 #C08B3E, 0 12px 40px rgba(180, 120, 40, 0.12) !important;
  padding: 28px !important;
  width: 400px !important;

  .el-message-box__header {
    padding: 0 0 14px !important;

    .el-message-box__title {
      color: var(--color-text, #3D2C1E) !important;
      font-size: 16px;
      font-weight: 700;
      font-family: "Fredoka", "Nunito Sans", sans-serif;
    }

    .el-message-box__headerbtn {
      width: 28px;
      height: 28px;
      background: var(--color-bg-alt, #FDECD8);
      border: none;
      border-radius: 50%;
      transition: all 0.2s ease;
      top: 0;
      right: 0;

      .el-message-box__close {
        color: var(--color-primary, #D4880F);
      }

      &:hover {
        background: linear-gradient(180deg, #FDEAC2, #F5C882);
        .el-message-box__close {
          color: var(--color-primary-dark, #A86B08);
        }
      }
    }
  }

  .el-message-box__content {
    padding: 0 0 20px !important;

    .el-message-box__container {
      .el-message-box__status {
        color: var(--color-primary, #D4880F) !important;
      }

      .el-message-box__message p {
        color: var(--color-text-light, #7A6355) !important;
        line-height: 1.6;
        font-family: "Nunito Sans", sans-serif;
      }
    }
  }

  .el-message-box__btns {
    padding: 0 !important;
    display: flex;
    justify-content: flex-end;
    gap: 10px;

    .el-button--primary {
      background: linear-gradient(180deg, #FDEAC2 0%, #F5C882 100%) !important;
      border: 2px solid var(--color-border-dashed, #D4A04A) !important;
      border-radius: 12px !important;
      font-size: 13px;
      font-weight: 700;
      color: var(--color-text, #3D2C1E) !important;
      padding: 8px 22px !important;
      height: auto !important;
      line-height: 1.5;
      box-shadow: 0 3px 0 #C08B3E;
      transition: all 0.2s ease;
      font-family: "Nunito Sans", sans-serif;

      &:hover {
        background: linear-gradient(180deg, #FFE8A8 0%, #F5C86E 100%) !important;
        transform: translateY(-1px);
        box-shadow: 0 4px 0 #C08B3E, 0 6px 12px rgba(180, 120, 40, 0.15);
      }
    }

    .el-button:not(.el-button--primary) {
      background: var(--color-bg-card, #fff) !important;
      border: 2px solid var(--color-border, #E8C9B0) !important;
      border-radius: 12px !important;
      color: var(--color-text-light, #7A6355) !important;
      font-size: 13px;
      font-weight: 600;
      padding: 8px 22px !important;
      height: auto !important;
      line-height: 1.5;
      transition: all 0.2s ease;
      font-family: "Nunito Sans", sans-serif;

      &:hover {
        border-color: var(--color-primary, #D4880F) !important;
        color: var(--color-primary, #D4880F) !important;
      }
    }
  }
}

// Mobile responsive
@media (max-width: 480px) {
  .el-message-box.messageBox {
    width: 88vw !important;
    padding: 20px !important;
    border-radius: 16px !important;

    .el-message-box__header {
      .el-message-box__title {
        font-size: 14px;
      }
    }

    .el-message-box__content {
      padding: 0 0 16px !important;

      .el-message-box__message p {
        font-size: 13px;
      }
    }

    .el-message-box__btns {
      .el-button--primary,
      .el-button:not(.el-button--primary) {
        padding: 7px 16px !important;
        font-size: 12px;
        border-radius: 10px !important;
      }
    }
  }
}
// 武侠宣纸支付确认框（令牌见 theme.scss --wx-*；!important 用于压过上方基础段与 Element Plus 默认样式）
.el-message-box.messageBox {
  background: var(--wx-paper-light) !important;
  border: 1px solid var(--wx-bronze) !important;
  border-radius: 6px !important;
  box-shadow: 0 0 0 4px rgba(250, 245, 232, 0.9), 0 0 0 5px var(--wx-bronze), var(--wx-shadow-hover) !important;
  font-family: var(--wx-font-body);

  .el-message-box__title {
    color: var(--wx-ink) !important;
    font-family: var(--wx-font-title) !important;
    font-size: 19px;
    letter-spacing: 1px;
  }

  .el-message-box__headerbtn {
    background: transparent;
    border: 1px solid var(--wx-bronze);
    border-radius: 3px;

    .el-message-box__close { color: var(--wx-ink-soft); }

    &:hover {
      background: var(--wx-ink-wash);
      .el-message-box__close { color: var(--wx-cinnabar); }
    }

    &:focus-visible {
      outline: 3px solid var(--wx-dai);
      outline-offset: 2px;
    }
  }

  .el-message-box__status {
    color: var(--wx-cinnabar) !important;
  }

  .el-message-box__message p {
    color: var(--wx-ink-soft) !important;
    font-family: var(--wx-font-body);
  }

  .el-message-box__btns {
    .el-button--primary {
      color: var(--wx-paper-light) !important;
      background: var(--wx-cinnabar) !important;
      border: none !important;
      border-radius: 3px 6px 2px 5px !important;
      box-shadow: inset 0 0 0 2px var(--wx-cinnabar), inset 0 0 0 3px rgba(250, 245, 232, 0.75), 0 2px 0 var(--wx-cinnabar-dark) !important;
      font-family: var(--wx-font-title);
      letter-spacing: 2px;

      &:hover {
        background: var(--wx-cinnabar-dark) !important;
        box-shadow: inset 0 0 0 2px var(--wx-cinnabar-dark), inset 0 0 0 3px rgba(250, 245, 232, 0.75), 0 2px 0 var(--wx-cinnabar-dark) !important;
      }
    }

    .el-button:not(.el-button--primary) {
      background: var(--wx-paper) !important;
      border: 1px solid var(--wx-bronze) !important;
      border-radius: 3px !important;
      color: var(--wx-ink-soft) !important;
      font-family: var(--wx-font-body);

      &:hover {
        border-color: var(--wx-cinnabar) !important;
        color: var(--wx-cinnabar) !important;
      }
    }

    .el-button:focus-visible {
      outline: 3px solid var(--wx-dai);
      outline-offset: 2px;
    }
  }
}
</style>
